import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';

import { checkDemoMode, displayDealershipName, showMsg } from '../../services/library';
import UserService from '../../services/userService';
import { EXPORT, IMPORT, MAVIS, TABLE_VIEW, TREE_VIEW } from '../../constants/messageConst';
import { hasActionPermission, performLogout, retrieveUserDetails } from '../../generalUtils/rbacUtils';
import {
  STORAGE_DEALER,
  STORAGE_THEME,
  STORAGE_TOGGLE_SALES_DEMO_MODE,
  STORAGE_USER,
  STORAGE_USER_VIEW
} from '../../constants/storageConst';
import { MODULE_APP_GLOBAL } from '../../constants/moduleSlugConst';
import { ACTION_ACTIVE_DEALER_IN_DD_LIST } from '../../constants/actionSlugConst';

const currentView = localStorage.getItem(STORAGE_USER_VIEW)
  ? JSON.parse(localStorage.getItem(STORAGE_USER_VIEW))
  : { import: TABLE_VIEW, export: TABLE_VIEW, mavis: TABLE_VIEW };

export const retrieveDealerDetails = () => {
  const dealerFromSession = sessionStorage.getItem(STORAGE_DEALER);
  const dealerFromLocal = localStorage.getItem(STORAGE_DEALER);

  try {
    return dealerFromLocal && dealerFromLocal !== 'undefined' && dealerFromLocal !== 'null'
      ? JSON.parse(dealerFromLocal)
      : dealerFromSession && dealerFromSession !== 'undefined' && dealerFromSession !== 'null'
      ? JSON.parse(dealerFromSession)
      : null;
  } catch (error) {
    console.error('Error parsing dealer data:', error);
    return null;
  }
};

export const fetchMyAllDealersReq = createAsyncThunk(
  'mainlayout/fetchMyAllDealersReq',
  async (_, { rejectWithValue }) => {
    try {
      const response = await UserService.getMyAllDealers();
      if (response?.status) {
        return { dealers: response.data[0].dealers, user: response.data[0].user };
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const retriveStorageThemeObj = () => {
  let obj = localStorage.getItem(STORAGE_THEME);
  const returnObj = {
    baseThemeColorArr: [],
    completeThemeSetArr: [],
    themeColorObj: {}
  };
  try {
    if (obj && obj !== 'null' && obj !== 'undefined') {
      obj = JSON.parse(obj);
    }
    return obj ?? returnObj;
  } catch (err) {
    console.log('retriveStorageThemeObj Error :- ', err);
    return returnObj;
  }
};

const mainLayoutSlice = createSlice({
  name: 'mainlayout',
  initialState: {
    isSidebarVisible: false,
    isLoading: false,
    changePasswordToggle: false,
    opDecalsToggle: false,
    windowStickerBuyersguideOrderToggle: false,
    screenSizeObj: null,
    isFullLayout: false,
    user: retrieveUserDetails(),
    dealer: retrieveDealerDetails(),
    allDealerList: [],
    activeDealersList: [],
    inActiveDealersList: [],
    pageTitle: '',
    pageBreadCrumb: [],
    themeArr: retriveStorageThemeObj(),
    view: currentView,
    isDemoMode: checkDemoMode(),
    needTraining: false,
    is5PmReportModalOpen: false,
    isPhotoReportModalOpen: false
  },
  reducers: {
    handleThemeArr: {
      reducer(state, action) {
        state.themeArr = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePageTitleNBreadCrumb: {
      reducer(state, action) {
        state.pageTitle = action.payload.pageTitle;
        state.pageBreadCrumb = action.payload.pageBreadCrumb;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleLayoutIsDisplaySidebar: {
      reducer(state, action) {
        state.isSidebarVisible = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleLayoutLoader: {
      reducer(state, action) {
        state.isLoading = action.payload;

        const { isSidebarVisible } = current(state);
        state.isFullLayout = !isSidebarVisible;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleLayoutSetUserInfo: {
      reducer(state, action) {
        const userJson = action.payload;
        if (userJson) {
          localStorage.setItem(STORAGE_USER, userJson ? JSON.stringify(userJson) : '');
          state.user = userJson;
        }
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleLayoutSetUserInfoSession: {
      reducer(state, action) {
        const userJson = action.payload;
        if (userJson) {
          sessionStorage.setItem(STORAGE_USER, userJson ? JSON.stringify(userJson) : '');
          state.user = userJson;
        }
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleUnSetUserNDealer: {
      reducer(state) {
        sessionStorage.removeItem(STORAGE_USER);
        localStorage.removeItem(STORAGE_USER);
        state.user = null;

        sessionStorage.removeItem(STORAGE_DEALER);
        localStorage.removeItem(STORAGE_DEALER);
        state.dealer = null;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    // handleAllDealerList: {
    //   reducer(state, action) {
    //     state.allDealerList = action.payload;
    //   },
    //   prepare(e) {
    //     return { payload: e };
    //   }
    // },
    handleLayoutSetDealerInfo: {
      reducer(state, action) {
        const dealerJson = action.payload;
        localStorage.setItem(STORAGE_DEALER, JSON.stringify(dealerJson));
        sessionStorage.setItem(STORAGE_DEALER, JSON.stringify(dealerJson));
        state.dealer = dealerJson;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleLayoutSetSessionDealerInfo: {
      reducer(state, action) {
        const dealerJson = action.payload;
        sessionStorage.setItem(STORAGE_DEALER, JSON.stringify(dealerJson));
        state.dealer = dealerJson;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleChangePasswordToggle: {
      reducer(state, action) {
        state.changePasswordToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleOpDecalsToggle: {
      reducer(state, action) {
        state.opDecalsToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleNeedTrainingToggle: {
      reducer(state, action) {
        state.needTraining = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleWindowStickerBuyersguideOrderToggle: {
      reducer(state, action) {
        state.windowStickerBuyersguideOrderToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleLayoutScreenSizeObj: {
      reducer(state, action) {
        state.screenSizeObj = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleIsFullLayout: {
      reducer(state, action) {
        state.isFullLayout = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFullLayoutLoader: {
      reducer(state, action) {
        state.isLoading = action.payload;
        state.isFullLayout = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    toggleView: {
      reducer(state, action) {
        const pageType = action.payload;
        if (![IMPORT, EXPORT, MAVIS].includes(pageType)) {
          return;
        }
        state.view[pageType] = state.view[pageType] === TABLE_VIEW ? TREE_VIEW : TABLE_VIEW;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleUpdateDemoMode: {
      reducer(state, action) {
        localStorage.setItem(STORAGE_TOGGLE_SALES_DEMO_MODE, action.payload);
        state.isDemoMode = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    set5PmReportModalOpen: {
      reducer(state, action) {
        state.is5PmReportModalOpen = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    setPhotoReportModalOpen: {
      reducer(state, action) {
        state.isPhotoReportModalOpen = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    }
  },
  extraReducers: builder => {
    builder
      //#region fetchMyAllDealersReq
      .addCase(fetchMyAllDealersReq.pending, state => {
        state.allDealerList = [];
        state.activeDealersList = [];
        state.inActiveDealersList = [];
      })
      .addCase(fetchMyAllDealersReq.fulfilled, (state, action) => {
        const { dealers } = action.payload;

        const { user } = action.payload;
        if (dealers?.length === 0) {
          state.allDealerList = [];
          state.activeDealersList = [];
          state.inActiveDealersList = [];

          performLogout();
        } else {
          const options = dealers.map(option => ({
            value: option.user_id,
            label: displayDealershipName(option.user_displayname),
            nicename: option.user_nicename,
            invid: option.dealer_invid,
            viewer: option.dealer_viewer,
            processingFlag: option.dealer_reframehero,
            active: parseInt(option.user_isactive),
            viewertype: option.dealer_viewertype,
            integration: option?.dealer_integration,
            dealerSticker: option?.dealer_sticker,
            promoBanner: option?.dealer_ispromobanner,
            promoBillboard: option?.dealer_ispromobillboard,
            importDownload: option?.dealer_is_import_download,
            shareVehicle: option?.dealer_is_share_vehicle,
            dealer_is43: option?.dealer_is43,
            exportUpload: option?.dealer_export_upload,
            isTestDealership: option?.dealer_is_test_dealership,
            minVehPhotos: {
              used: option?.dealer_used_veh_min_photos || 0,
              new: option?.dealer_new_veh_min_photos || 0
            },
            salesforceId: option?.dealer_salesforce_id || '',
            allowStickerOrderDashboard: option?.dealer_allow_win_sticker_order === 1
            // dealerEncPhotonUrl: option?.dealer_isencphotonurl
          }));

          const activeDealers = options.filter(dealer => parseInt(dealer.active) === 1);
          state.activeDealersList = activeDealers;

          if (hasActionPermission([ACTION_ACTIVE_DEALER_IN_DD_LIST], [MODULE_APP_GLOBAL])) {
            state.inActiveDealersList = options.filter(dealer => parseInt(dealer.active) === 0);
            state.allDealerList = options || [];
          } else {
            state.allDealerList = activeDealers || [];
          }

          if (!retrieveDealerDetails()) {
            const dealerJson = activeDealers?.length > 0 ? activeDealers[0] : null;
            if (dealerJson) {
              localStorage.setItem(STORAGE_DEALER, JSON.stringify(dealerJson));
              sessionStorage.setItem(STORAGE_DEALER, JSON.stringify(dealerJson));
              state.dealer = dealerJson;
            }
          }

          // All Dealer list empty than logout
          const { allDealerList } = current(state);
          if (!allDealerList || allDealerList?.length === 0) {
            showMsg(['All Dealership list not found.'], 'error');
            performLogout();
          }
        }
        if (user && user.user_role_name) {
          const storedUser = localStorage.getItem(STORAGE_USER);
          if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            parsedUser.user_role_name = user.user_role_name;
            parsedUser.user_role_slug = user.user_role_slug;

            localStorage.setItem(STORAGE_USER, JSON.stringify(parsedUser));
          }
        }
      })
      .addCase(fetchMyAllDealersReq.rejected, state => {
        state.allDealerList = [];
        state.activeDealersList = [];
        state.inActiveDealersList = [];
      });
    // #endregion
  }
});

export const {
  handlePageTitleNBreadCrumb,
  handleLayoutIsDisplaySidebar,
  handleLayoutLoader,
  handleLayoutSetUserInfo,
  handleLayoutSetDealerInfo,
  handleChangePasswordToggle,
  handleOpDecalsToggle,
  handleWindowStickerBuyersguideOrderToggle,
  handleLayoutScreenSizeObj,
  handleIsFullLayout,
  handleFullLayoutLoader,
  handleThemeArr,
  handleLayoutSetUserInfoSession,
  handleLayoutSetSessionDealerInfo,
  handleUnSetUserNDealer,
  toggleView,
  handleUpdateDemoMode,
  handleNeedTrainingToggle,
  set5PmReportModalOpen,
  setPhotoReportModalOpen
} = mainLayoutSlice.actions;
export default mainLayoutSlice.reducer;
